import React, { useContext } from "react";
import { StaticImage } from "gatsby-plugin-image";
import { DesktopNavItem } from "./components/DesktopNavItem";
import environments from "../../utils/config/environments";
import { MobileMenuButton } from "./components/MobileMenuButton";
import { useHeader } from "./hooks/useHeader";
import { MobileNavMenu } from "./components/MobileNavMenu";
import { LangContext } from "../../context/lang/LangContext";
import { LangSelect } from "../LangSelect/LangSelect";
import { Link } from "gatsby";

const Header = () => {
  const { messages } = useContext(LangContext);

  const { menuItems, handleOpenMenu, openMenu, onClickBookADemo } = useHeader();
  return (
    <header className="Header__container">
      <div className="Header__items_container">
        <Link to={`/${messages.currentLanguage}`}>
          <StaticImage
            layout="constrained"
            src="../../images/c4c7us-logo.svg"
            alt="logo"
            className="Header__logo"
          />
        </Link>
        <nav className="Header__nav">
          {menuItems.map((item, index) => (
            <DesktopNavItem key={index} item={item} />
          ))}
        </nav>
        <div className="Header__buttons_container">
          <a
            href={environments.signInLink}
            className="Landing__button Landing__button_secondary"
            target="_blank"
            rel="noreferrer"
          >
            {messages.header.buttons.signIn}
          </a>
          <a
            href={environments.createAccountLink}
            className="Landing__button"
            target="_blank"
            rel="noreferrer"
            onClick={onClickBookADemo}
          >
            {messages.header.buttons.getPricing}
          </a>
          <LangSelect />
        </div>
        <MobileMenuButton handleOpenMenu={handleOpenMenu} />
        <MobileNavMenu
          handleOpenMenu={handleOpenMenu}
          items={menuItems}
          isOpen={openMenu}
        />
      </div>
    </header>
  );
};

export default Header;
